import React from 'react';
import { Details } from './index';
import { withStyles, Grid, Tooltip } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';

const styles = (theme) => ({
  container: {
    marginTop: 8,
    paddingTop: 8,
    borderTop: `1px solid ${theme.AppBGColor}`
  },
  iconStyle: {
    cursor: 'pointer',
    color: theme.iconColor,
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-end'
  },
});

const DuplicatePickupInfo = (props) => {
  const { classes } = props;
  return (
    <Grid container className={classes.container}>
      <Grid item xs={4}>
        <Details label="Pickup#:" value={props.pickupNumber} />
      </Grid>
      <Grid item xs={7}>
        <Details
          label="Shipper:"
          noWrap={true}
          value={`${props.shipperName} (${props.shipperAccountNumber}) | ${props.shipperAddress}`}
        />
      </Grid>
      {props.enablePickupEdit && (
        <Grid item xs={1} className={classes.iconStyle} onClick={() => props.onEdit(props)}>
          <Tooltip title="Edit Pickup">
            <EditIcon />
          </Tooltip>
        </Grid>
      )}
      <Grid container item xs={12}>
        <Grid item xs={4}>
          <Details label="Ready Time:" value={props.pickupReadyTime} />
        </Grid>
        <Grid item xs={3}>
          <Details label="Close Time:" value={props.pickupCloseTime} />
        </Grid>
        <Grid item xs={5}>
          <Details
            label="Driver:"
            value={props.driverNumber ? `${props.driverName} (${props.driverNumber})` : ''}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default withStyles(styles)(DuplicatePickupInfo);
